import { CarriersController } from "../controllers/carriers-controller";
import { Carrier } from "../models/carrier"
import { CarrierFilter } from "../models/carrier-filter"
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

//import 'ag-grid-enterprise/main';
import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import * as condition from './widgets/list-filter/condition';
import { SecurityService } from "../services/security-service";
import { Globals } from "../models/globals";

@singleton()
@autoinject()
export class Carriers {

    constructor(
        private securityService: SecurityService,
        private busyService: BusyService,
        private carriersController: CarriersController,
        private api: WebApiService) {
    }

    activate() {

        if (!this.conditions) {
            this.conditions = [condition.getDefaultCondition()];
        }

        if (!this.carriers) {
            this.search();
        }

        this.loadCarrierStatuses();
        this.loadMills();
        this.loadEquipment();

    }

    fields: Array<condition.ConditionField>;
    isAllMillsSelected: boolean;

    @observable()
    savedSearch: string;
    savedSearchChanged() {
        //if (this.savedSearch == "master-approved") {
        //    this.conditions = [{ "value": { "id": "Master Approved", "description": "Master Approved" }, "chainOperator": "and", "field": { "label": "Status", "name": "StatusDescription", "type": 4, "list": [{ "id": "New", "description": "New" }, { "id": "Potential", "description": "Potential" }, { "id": "Packet Sent", "description": "Packet Sent" }, { "id": "In Process", "description": "In Process" }, { "id": "Minimum Requirements", "description": "Minimum Requirements" }, { "id": "Insurance Complete", "description": "Insurance Complete" }, { "id": "NLC Approved", "description": "NLC Approved" }, { "id": "Master Approved", "description": "Master Approved" }, { "id": "Not Qualified", "description": "Not Qualified" }, { "id": "Inactive", "description": "Inactive" }] }, "operation": { "operator": "equals", "input": true } }];
        //    console.log(JSON.stringify(this.conditions));
        //    this.search(this.conditions);
        //}
    }

    loadFields() {
        if (!this.fields) {
            this.fields = [];
            //this.fields.push(<condition.ConditionField>{ name: "legalName", label: "Legal Name", type: condition.ConditionFieldType.string });
            //this.fields.push(<condition.ConditionField>{ name: "dotNumber", label: "DOT Number", type: condition.ConditionFieldType.string });
            //this.fields.push(<condition.ConditionField>{ name: "mcNumber", label: "MC Number", type: condition.ConditionFieldType.string });
            //this.fields.push(<condition.ConditionField>{
            //    name: "statusId",
            //    label: "Status",
            //    type: condition.ConditionFieldType.list,
            //    defaultOperator: "equals",
            //    list: [
            //        { id: 0, description: "New" },
            //        { id: 2, description: "Potential" },
            //        { id: 3, description: "Packet Sent" },
            //        { id: 4, description: "In Process" },
            //        { id: 5, description: "Minimum Requirements" },
            //        { id: 6, description: "Insurance Complete" },
            //        { id: 7, description: "NLC Approved" },
            //        { id: 8, description: "Master Approved" },
            //        { id: 9, description: "Not Qualified" },
            //        { id: 10, description: "Inactive" }
            //    ]
            //});

            var columnApi = this.gridApi.getModel().columnApi
            var columns = columnApi.getAllColumns();
            columns.forEach(c => {
                var conditionField = new condition.ConditionField();
                conditionField.label = c.colDef.headerName || c.colDef.field;
                conditionField.name = c.colDef.field;
                conditionField.type = c.colDef.searchType;
                if (c.colDef.searchList) {
                    conditionField.list = c.colDef.searchList;
                } else if (c.colDef.searchListQuery) {
                    this.executeQuery(c.colDef.searchListQuery)
                        .then(result => {
                            conditionField.list = result
                        });
                }
                this.fields.push(conditionField);
            });

            this.fields.sort((a, b) => {
                if (a.label < b.label)
                    return -1;
                else if (a.label > b.label)
                    return 1;
                else return 0;
            });
        }
    }

    loadCarrierStatuses() {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierStatuses")
            .then((result) => {
                this.carrierStatuses = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    loadMills() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                let mills = JSON.parse(result.response);
                const userDivisions = this.securityService.user.millCodes;
                if (userDivisions.length > 0) {
                    mills = mills.filter(o => userDivisions.indexOf(o.millId) > -1);
                }
                this.mills = mills;
            })
            .finally(() => {
                this.busyService.off();
            });
    }


    loadEquipment() {
        this.busyService.on();
        this.api.get("Registration", "GetEquipment")
            .then((result) => {
                this.equipment = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    gridContainer: any;
    carrierStatuses: any;
    @observable
    gridApi: any;
    gridApiChanged(gridApi) {
        this.applyFilters();
        this.applyGridLayout();
        this.loadFields();  //load fields collection for filter panel
    }

    applyFilters() {
        this.quickFilterChanged();
    }

    applyGridLayout() {
        //apply user's personalized grid layout


    }
    personalizeColumns() {
        if (this.gridApi) {
            var columnApi = this.gridApi.getModel().columnApi
            var columns = columnApi.getAllColumns();
            columnApi.setColumnVisible("Id", true);
        }
    }
    saveGridLayout() {
    }

    @computedFrom("carriers.length",
        "selectedMills.length",
        "selectedEquipment.length",
        "selectedStatuses.length",
        "selectedCarrierActiveStatuses.length",
        "selectedInsuranceStatuses.length",
        "selectedContractTypes.length",
        "selectedCarrierTypes.length",
        "selectedAuthorityTypes.length"
    )
    get filteredCarriers(): Array<any> {
        var carriers = this.carriers;

        //save search criteria
        //AureliaCookie.set('search.selectedMills', JSON.stringify(this.selectedMills), null);

        //carrier mill

        if (!carriers) return [];

        carriers = carriers.filter((item: any) => {

            // Per Rebecca Kelly, the general carrier search screen should not limit results based on user's assigned mills.
            //// if user has divisions assigned, then only show carriers that are assigned to that mill
            //let userDivisions = this.securityService.user.millCodes;
            //if (userDivisions.length > 0) {
            //    return item.Mills && item.Mills.length
            //        && userDivisions.find(o => item.Mills.indexOf(o) > -1)
            //        && (this.isAllMillsSelected || this.selectedMills.find(m => {
            //            return item.Mills.indexOf(m) > -1;
            //        }));
            //} else {
            //    return (this.isAllMillsSelected || this.selectedMills.find(m => {
            //        return item.Mills && item.Mills.length && item.Mills.indexOf(m) > -1;
            //    }));
            //}
            return (this.isAllMillsSelected || this.selectedMills.find(m => {
                return item.Mills && item.Mills.length && item.Mills.indexOf(m) > -1;
            }));

        });


        //carrier status
        if (this.selectedStatuses.length > 0) {
            carriers = carriers.filter((item: any) => {
                return this.selectedStatuses.indexOf(item.StatusDescription) > -1;
            });
        }

        //active/inactive
        if (this.selectedCarrierActiveStatuses.length > 0) {
            carriers = carriers.filter((item: any) => {
                return this.selectedCarrierActiveStatuses.indexOf(item.Active) > -1;
            });
        }

        //insurance status
        if (this.selectedInsuranceStatuses.length > 0) {
            carriers = carriers.filter((item: any) => {
                return this.selectedInsuranceStatuses.indexOf(item.InsuranceStatus) > -1;
            });
        }

        //equipment
        if (this.selectedEquipment.length > 0) {
            carriers = carriers.filter((item: any) => {
                return item.Equipment && item.Equipment.length > 0 && !!this.selectedEquipment.find(m => {
                    return item.Equipment.indexOf(m) > -1;
                });
            });
        }


        //selectedCarrierTypes
        if (this.selectedCarrierTypes.length > 0) {
            carriers = carriers.filter((item: any) => {
                return this.selectedCarrierTypes.indexOf(item.EntityType) > -1;
            });
        }

        //selectedContractTypes
        if (this.selectedContractTypes.length > 0) {
            carriers = carriers.filter((item: any) => {
                return this.selectedContractTypes.indexOf(item.ContractType) > -1;
            });
        }

        //selectedAuthorityTypes
        if (this.selectedAuthorityTypes.length > 0) {
            carriers = carriers.filter((item: any) => {
                return this.selectedAuthorityTypes.indexOf(item.TypeOfAuthority) > -1;
            });
        }

        return carriers;
    }


    //search(reload: boolean = false) {
    //    if (reload || !this.carriers) {

    //        this.busyService.on();
    //        this.carriersController.searchCarriers(this.filter)
    //            .then((result) => {
    //                this.carriers = JSON.parse(result.response);
    //            })
    //            .finally(() => this.busyService.off());

    //    }

    //    //setTimeout(() => {
    //    //    this.carriers[0].legalName = "TOM";
    //    //}, 3000);
    //}

    @observable
    quickFilter: string;
    quickFilterChanged() {
        this.gridApi && this.gridApi.setQuickFilter(this.quickFilter);
    }

    carriers: Array<Object>
    @observable
    filter: CarrierFilter = new CarrierFilter();


    statuses: Array<any> = [
        { id: 1, description: "New" },
        { id: 3, description: "Complete" }
    ];
    selectedStatuses: Array<any> = [];


    contractTypes: Array<any> = [
        { id: "Small", description: "Small" },
        { id: "Master", description: "Master" },
        { id: "Modified", description: "Modified" },
        { id: "Single Facility", description: "Single Facility" },
        { id: "Addendum", description: "Addendum" },
        { id: "Transloader", description: "Transloader" },
        { id: "TransloaderVehicles", description: "TransloaderVehicles" }
    ];
    selectedContractTypes: Array<any> = [];

    carrierTypes = new Globals().getEntityTypes();
    selectedCarrierTypes: Array<any> = [];


    authorityTypes: Array<any> = [
        { id: "BROKERAGE", description: "Brokerage" },
        { id: "PERMIT", description: "Asset Carrier" },
        { id: "BOTH", description: "Carrier W/ Brokerage Authority" }
    ];
    selectedAuthorityTypes: Array<any> = [];


    mills: Array<any> = [];
    selectedMills: Array<any> = [];//this.getObjectFromCookie("search.selectedMills", []);

    equipment: Array<any> = [];
    selectedEquipment: Array<any> = [];

    selectedInsuranceStatuses: Array<any> = [];
    insuranceStatuses: Array<any> = [
        { id: 'None', description: "No Insurance" },
        { id: 'Active', description: "Insurance Active" },
        { id: 'Expired', description: "Insurance Expired" }
    ];

    selectedCarrierActiveStatuses: Array<any> = [];
    carrierActiveStatuses: Array<any> = [
        { id: true, description: "Active" },
        { id: false, description: "Inactive" }
    ];

    exportGrid() {
        this.gridApi.exportDataAsCsv();
    }

    //getObjectFromCookie(name, defaultValue) {
    //    var val = AureliaCookie.get(name);
    //    if (val) {
    //        return JSON.parse(defaultValue);
    //    } else {
    //        return defaultValue;
    //    }
    //}

    conditions: Array<any>;
    search(force: boolean = false) {

        //clear post-search filters
        this.quickFilter = "";
        this.selectedMills = [];
        this.selectedEquipment = [];
        this.selectedStatuses = [];
        this.selectedCarrierActiveStatuses = [];
        this.selectedInsuranceStatuses = [];

        //build a set of conditions
        var apiConditions = this.buildConditionsForApi();

        console.log(JSON.stringify(apiConditions));

        //pass in conditions to force reload;
        if (force || !this.carriers) {
            //clean the conditions in case ones are stored with empty fields (like the default condition)
            var params = {
                searchConditions: apiConditions,
                table: "CarriersFlattened"
            };
            return this.api.submit("Carriers", "ExecuteSearchQuery", params)
                .then((result) => {
                    this.carriers = JSON.parse(result.response);
                })
        }
    }


    executeQuery(query) {
        return this.api.submit("Carriers", "ExecuteSearchQuery", query)
            .then((result) => {
                return JSON.parse(result.response);
            })
    }


    buildConditionsForApi() {
        var conditions = this.conditions.filter(o => typeof o.field == "object").map(c => {
            return {
                chainOperator: c.chainOperator,
                fieldName: c.field.name,
                fieldType: c.field.type,
                searchOp: c.operation.operator,
                value: typeof c.value == "string" ? c.value : c.value.id
            };
        });
        return conditions
    }



}
